export default {
    /* GET_PRODUCTION_SITE_NOTES
    ------------------------------------------------------------
    */
    GET_PRODUCTION_SITE_NOTES_REQUEST: (state) => {
        state.productionSiteNotesLoading = true
    },
    GET_PRODUCTION_SITE_NOTES_SUCCESS: (state, data) => {
        state.productionSiteNotes = data.results
        state.productionSiteNotesLoading = false
    },
    GET_UNREAD_PRODUCTION_SITE_NOTES_SUCCESS: (state, count) => {
        state.unreadProductionSiteNotes = count
        state.productionSiteNotesLoading = false
    },
    GET_PRODUCTION_SITE_NOTES_FAILURE: (state) => {
        state.productionSiteNotesLoading = false
    },
    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
}